import React, { Component, Fragment } from "react";
import withRouter from "../withRouter/withRouter";
import ListScroll from "../ListScroll/ListScroll";
import Comment from "./Comment/Comment";
import { toPersianNumber } from "../../classes/utils";
import no_image_img from "../../no-image.png";

import "./Item.css";
import ItemCard from "../ListItem/ItemCard";

class Item extends Component {
    constructor(props) {
        super(props);
        this.connection = this.props.connection;
        this.orderForm = React.createRef();
        this.newComment = React.createRef();
        this.no_image = { url: no_image_img };

        this.sendComment = this.sendComment.bind(this);
        this.onCommentClick = this.onCommentClick.bind(this);
        this.userAction = this.userAction.bind(this);
    }
    state = {
        id: this.props.router.params.id,
        costumer: null,
        item: {},
        selectedColor: null,
        orderAmount: 0,
        selectedImage: null,
        relatedItems: [],
        canComment: false,
        comments: null,
    };

    componentDidMount() {
        let { id } = this.props.router.params;
        this.connection
            .get_item(id)
            .then((res) => {
                let { item } = res.data;
                this.setState({
                    item,
                    selectedColor: item.colors[0],
                    orderAmount: item.retail_min_amount,
                    selectedImage: item.medias[0],
                });
            })
            .catch((err) => {
                console.log(err);
            });

        this.connection
            .get_related_items(id, 5)
            .then((res) => {
                this.setState({ relatedItems: res.data });
            })
            .catch((err) => {
                console.log(err);
            });

        this.connection
            .get_filtered_data("comments", { item: id })
            .then((res) => {
                this.setState({ comments: res.data.comments });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    componentDidUpdate() {
        let { costumer, router } = this.props;
        let { id } = router.params;

        if (id !== this.state.id) {
            this.setState({ id });
            this.componentDidMount();
        }

        if (this.state.costumer !== costumer) {
            this.setState({ costumer });
            costumer &&
                this.connection
                    .can_costumer_comment_on(this.state.id)
                    .then((res) => {
                        this.setState({ canComment: true });
                    })
                    .catch((err) => {
                        this.setState({ canComment: false });
                    });
        }
    }

    onCommentClick(id, checkbox, message) {
        let { selectedComment: prevSelected } = this.state;
        if (prevSelected && prevSelected.id === id) {
            this.setState({ selectedComment: null });
            checkbox.checked = false;
        } else {
            if (prevSelected && prevSelected.checkbox)
                prevSelected.checkbox.checked = false;
            this.setState({
                selectedComment: { id, checkbox, message: message + id },
            });
            checkbox.checked = true;
        }
    }

    sendComment() {
        let { costumer } = this.props;
        let { name, mobile } = costumer;
        let { selectedComment, id } = this.state;
        let newComment = this.newComment.current.value;

        this.connection
            .put_comment({
                poster: { name, mobile },
                message: newComment,
                item: id,
                reply_to: selectedComment && selectedComment.id,
            })
            .then((res) => {
                this.props.toast(
                    "ثبت نظر",
                    "نظر شما ثبت شد. بعد از تایید نظر توسط مدیر به نمایش در خواهد آمد",
                    " confirm",
                    10000
                );
            })
            .catch((err) => {
                this.props.toast(
                    "ثبت نظر",
                    "خطا در ارسال نظر" + err,
                    " danger"
                );
            });
    }

    userAction(action, id, set) {
        let { toast, connection, costumer, router } = this.props;
        if (!costumer.signed) router.navigate("/register/item/" + id);
        const m_action = set ? "افزودن به" : "حذف از";
        const m_prop =
            action === "notifies"
                ? "لسیت اعلان موجودی"
                : action === "favorites"
                ? "لیست علاقه مندی ها"
                : null;
        if (!m_prop) {
            return;
        }
        connection
            .user_action_on_item(action, id, set)
            .then((res) => {
                toast(
                    `${m_prop}`,
                    `${m_action} ${m_prop} با موفقیت انجام شد.`,
                    " confirm"
                );

                costumer[action] = res.data[action];
                this.setState({ costumer });
            })
            .catch((res) => {
                toast(
                    `${m_prop}`,
                    `${m_action} ${m_prop} با خطا مواجه شد.`,
                    " danger"
                );
            });
    }

    render() {
        let {
            item,
            selectedColor,
            orderAmount,
            selectedImage,
            relatedItems,
            canComment,
            selectedComment,
            comments,
            costumer,
        } = this.state;
        let {
            name,
            categories,
            colors,
            description,
            has_wholesale,
            id,
            is_special_offer,
            is_suggestion,
            medias,
            retail_discount,
            retail_min_amount,
            retail_price,
            speces,
            special_offer_discount,
            step,
            unit,
            weight_per_unit,
            wholesale_price,
            wholesale_discount,
            wholesale_min_amount,
        } = item;
        let hasDiscount =
            (is_special_offer && special_offer_discount) || retail_discount;

        const isFavorite =
            costumer &&
            costumer.signed &&
            costumer.favorites &&
            costumer.favorites.find((f) => {
                return f.id == id;
            })
                ? true
                : false;

        const isNotify =
            costumer &&
            costumer.signed &&
            costumer.notifies &&
            costumer.notifies.find((n) => {
                return n.id == id;
            })
                ? true
                : false;
        return (
            <div className='ItemComponent'>
                <div className='ItemContainer'>
                    <form id='order' ref={this.orderForm}></form>
                    <div className='overall'>
                        <div className='medias'>
                            {medias && medias.length > 0 && (
                                <Fragment>
                                    <div className='preview'>
                                        <div className='media'>
                                            {selectedImage ? (
                                                selectedImage.type ===
                                                "image" ? (
                                                    <img
                                                        src={selectedImage.url}
                                                    />
                                                ) : (
                                                    <video
                                                        src={selectedImage.url}
                                                        controls
                                                    ></video>
                                                )
                                            ) : (
                                                <img src={this.no_image.url} />
                                            )}
                                        </div>
                                    </div>
                                    <div className='all'>
                                        <ListScroll
                                            items={medias}
                                            key={"url"}
                                            Component={(props) => {
                                                let { item } = props;
                                                return (
                                                    <div
                                                        onClick={(ev) =>
                                                            this.setState({
                                                                selectedImage:
                                                                    item,
                                                            })
                                                        }
                                                    >
                                                        {item.type ===
                                                        "image" ? (
                                                            <img
                                                                className='media'
                                                                src={item.url}
                                                            />
                                                        ) : (
                                                            <video
                                                                className='media'
                                                                src={item.url}
                                                            ></video>
                                                        )}
                                                    </div>
                                                );
                                            }}
                                        />
                                    </div>
                                </Fragment>
                            )}
                        </div>
                        <div className='info'>
                            <h1 className='name text info'>{name}</h1>
                            <div className='actions'>
                                <div
                                    className='favorite text confirm'
                                    onClick={(ev) => {
                                        this.userAction(
                                            "favorites",
                                            id,
                                            !isFavorite
                                        );
                                    }}
                                >
                                    <i
                                        class={`ri-heart-${
                                            isFavorite ? "fill" : "line"
                                        }`}
                                    ></i>
                                    <div className='desc'>
                                        {isFavorite
                                            ? `حذف از علاقه مندی ها`
                                            : `افزودن به علاقه مندی ها`}
                                    </div>
                                </div>
                                {/* {((selectedColor &&
                                    parseFloat(selectedColor.available_amount) <
                                        parseFloat(step)) ||
                                    isNotify) && (
                                    <div
                                        className='notify text info'
                                        onClick={(ev) => {
                                            this.userAction(
                                                "notifies",
                                                id,
                                                !isNotify
                                            );
                                        }}
                                    >
                                        <i
                                            class={`ri-notification-${
                                                isNotify ? "fill" : "line"
                                            }`}
                                        ></i>
                                        <div className='desc'>
                                            موجود شد به من خبر بده
                                        </div>
                                    </div>
                                )} */}
                            </div>
                            <h4 className='price'>
                                <div className='retail'>
                                    <h3 className='caption secondary'>
                                        {has_wholesale
                                            ? "قیمت خرید خرد"
                                            : "قیمت"}
                                        :
                                    </h3>
                                    {hasDiscount && (
                                        <Fragment>
                                            <div className='actual text'>
                                                {toPersianNumber(
                                                    parseInt(retail_price),
                                                    true
                                                )}
                                            </div>
                                            <div className='discountPercent'>
                                                {toPersianNumber(
                                                    parseInt(
                                                        ((is_special_offer
                                                            ? parseInt(
                                                                  special_offer_discount
                                                              ) || 0
                                                            : 0 +
                                                              (parseInt(
                                                                  retail_discount
                                                              ) || 0)) /
                                                            parseInt(
                                                                retail_price
                                                            )) *
                                                            100
                                                    )
                                                )}
                                                % تخفیف
                                            </div>
                                        </Fragment>
                                    )}

                                    <div className='final text info'>
                                        <i className='ri-currency-line text warning'></i>
                                        <div className='number'>
                                            {retail_price &&
                                                toPersianNumber(
                                                    hasDiscount
                                                        ? retail_price -
                                                              (is_special_offer
                                                                  ? parseInt(
                                                                        special_offer_discount
                                                                    ) || 0
                                                                  : 0 +
                                                                    (parseInt(
                                                                        retail_discount
                                                                    ) || 0))
                                                        : retail_price,
                                                    true
                                                )}
                                        </div>
                                        تومان
                                    </div>
                                </div>

                                {has_wholesale && (
                                    <Fragment>
                                        <div className='wholesale'>
                                            <h3 className='caption secondary'>
                                                قیمت خرید عمده:
                                            </h3>
                                            {(special_offer_discount ||
                                                retail_discount) && (
                                                <Fragment>
                                                    <div className='actual text'>
                                                        {toPersianNumber(
                                                            parseInt(
                                                                wholesale_price
                                                            ),
                                                            true
                                                        )}
                                                    </div>
                                                    <div className='discountPercent '>
                                                        {toPersianNumber(
                                                            parseInt(
                                                                ((is_special_offer
                                                                    ? parseInt(
                                                                          special_offer_discount
                                                                      ) || 0
                                                                    : 0 +
                                                                      (parseInt(
                                                                          wholesale_discount
                                                                      ) || 0)) /
                                                                    parseInt(
                                                                        wholesale_price
                                                                    )) *
                                                                    100
                                                            )
                                                        )}
                                                        % تخفیف
                                                    </div>
                                                </Fragment>
                                            )}

                                            <div className='final text info'>
                                                <i className='ri-currency-line text warning'></i>
                                                <div className='number'>
                                                    {wholesale_price &&
                                                        toPersianNumber(
                                                            hasDiscount
                                                                ? wholesale_price -
                                                                      (is_special_offer
                                                                          ? parseInt(
                                                                                special_offer_discount
                                                                            ) ||
                                                                            0
                                                                          : 0 +
                                                                            (parseInt(
                                                                                wholesale_discount
                                                                            ) ||
                                                                                0))
                                                                : wholesale_price,
                                                            true
                                                        )}
                                                </div>
                                                تومان
                                            </div>
                                        </div>

                                        {has_wholesale && (
                                            <div className='caution text warning'>
                                                <i className='ri-feedback-line text '>
                                                    {" "}
                                                </i>
                                                <div className='message'>
                                                    خرید عمده برای این کالا
                                                    مقادیر
                                                    <div className='amount text secondary'>
                                                        بیشتر از{" "}
                                                        {wholesale_min_amount}{" "}
                                                        {unit}
                                                    </div>
                                                    میباشد.
                                                </div>
                                            </div>
                                        )}

                                        <div className='caution text info'>
                                            <i className='ri-feedback-line text '>
                                                {" "}
                                            </i>
                                            <div className='message'>
                                                قیمت برابر با قیمت هر
                                                <div className='amount text secondary'>
                                                    یک {unit}
                                                </div>
                                                میباشد.
                                            </div>
                                        </div>
                                    </Fragment>
                                )}
                            </h4>
                            <div className='speces'>
                                {speces &&
                                    Object.keys(speces).map((key) => {
                                        return (
                                            <div className='row' key={key}>
                                                <h2 className='cell'>{key}</h2>
                                                <h2 className='cell'>
                                                    {speces[key]}
                                                </h2>
                                            </div>
                                        );
                                    })}
                            </div>
                            <div className='addToCart'>
                                <div className='caption'>
                                    <i className='ri-shopping-cart-2-fill'></i>
                                    سفارش
                                </div>
                                <div className='colors'>
                                    <div className='caption secondary'>
                                        <i className='ri-palette-line'></i>
                                        رنگ ها:
                                    </div>
                                    {colors &&
                                        colors.length > 0 &&
                                        colors.map((color, index) => {
                                            return (
                                                <div
                                                    key={color.color.color}
                                                    className={
                                                        "color " +
                                                        (selectedColor &&
                                                            (color.color
                                                                .color ===
                                                            selectedColor.color
                                                                .color
                                                                ? " selected"
                                                                : ""))
                                                    }
                                                    style={{
                                                        backgroundColor:
                                                            color.color.color,
                                                    }}
                                                    onClick={(ev) => {
                                                        this.setState({
                                                            selectedColor:
                                                                color,
                                                            orderAmount:
                                                                retail_min_amount,
                                                        });
                                                    }}
                                                >
                                                    <i className='fa-solid fa-check tick'></i>
                                                    <div className='name'>
                                                        {color.color.name}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                                {selectedColor &&
                                parseFloat(selectedColor.available_amount) >=
                                    parseFloat(step) ? (
                                    <Fragment>
                                        <div className='orderAmount'>
                                            <div className='caption'>
                                                <i className='fa-solid fa-cubes-stacked '></i>
                                                مقدار سفارش
                                            </div>
                                            <input
                                                type='range'
                                                min={retail_min_amount}
                                                max={
                                                    (selectedColor &&
                                                        parseFloat(
                                                            selectedColor.available_amount
                                                        )) ||
                                                    0
                                                }
                                                step={step}
                                                value={orderAmount}
                                                onChange={(ev) =>
                                                    this.setState({
                                                        orderAmount:
                                                            ev.target.value,
                                                    })
                                                }
                                            />
                                            <div className='number'>
                                                <button
                                                    onClick={(ev) => {
                                                        let newValue =
                                                            parseFloat(
                                                                this.state
                                                                    .orderAmount
                                                            ) +
                                                            parseFloat(step);

                                                        this.setState({
                                                            orderAmount:
                                                                newValue >
                                                                selectedColor.available_amount
                                                                    ? selectedColor.available_amount
                                                                    : newValue,
                                                        });
                                                    }}
                                                >
                                                    <i className='ri-add-line btn info'></i>
                                                </button>
                                                <input
                                                    type='number'
                                                    name='amount'
                                                    form='order'
                                                    value={orderAmount}
                                                    onChange={(ev) => {
                                                        let value = parseFloat(
                                                            ev.target.value
                                                        );
                                                        if (
                                                            value >
                                                            selectedColor.available_amount
                                                        ) {
                                                            value =
                                                                selectedColor.available_amount;
                                                        }
                                                        if (
                                                            value <
                                                            retail_min_amount
                                                        ) {
                                                            value =
                                                                retail_min_amount;
                                                        }

                                                        if (
                                                            value !==
                                                            ev.target.value
                                                        ) {
                                                            ev.target.value =
                                                                value;
                                                        }
                                                        this.setState({
                                                            orderAmount:
                                                                parseInt(
                                                                    value / step
                                                                ) * step,
                                                        });
                                                    }}
                                                />
                                                <button
                                                    onClick={(ev) => {
                                                        let newValue =
                                                            parseFloat(
                                                                this.state
                                                                    .orderAmount
                                                            ) -
                                                            parseFloat(step);

                                                        this.setState({
                                                            orderAmount:
                                                                newValue <
                                                                retail_min_amount
                                                                    ? retail_min_amount
                                                                    : newValue,
                                                        });
                                                    }}
                                                >
                                                    <i className='ri-subtract-line btn danger'></i>
                                                </button>
                                            </div>

                                            {unit}
                                        </div>
                                        {step != 1 && unit != "عدد" && (
                                            <div className='caution text warning'>
                                                <i className='ri-feedback-line text '>
                                                    {" "}
                                                </i>
                                                <div className='message'>
                                                    کمترین میزان تغیر مقدار
                                                    سفارش
                                                    <div className='amount text secondary'>
                                                        {parseFloat(step)}{" "}
                                                        {unit}
                                                    </div>
                                                    میباشد. مثلا میزان سفارش
                                                    <div className='amount text secondary'>
                                                        {parseFloat(step * 3)}{" "}
                                                        {unit}
                                                    </div>
                                                    صحیح است اما
                                                    <div className='amount text secondary'>
                                                        {parseFloat(step * 2.5)}{" "}
                                                        {unit}
                                                    </div>
                                                    اشتباه است.
                                                </div>
                                            </div>
                                        )}

                                        <div className='finish'>
                                            <button
                                                className='orderBtn btn confirm'
                                                onClick={(ev) =>
                                                    this.props.addToCart(
                                                        item,
                                                        selectedColor,
                                                        orderAmount
                                                    )
                                                }
                                            >
                                                <i className='fa-solid fa-cart-plus'></i>
                                                اضافه کردن به سبد خرید
                                            </button>

                                            <div className='totalPrice'>
                                                {toPersianNumber(
                                                    orderAmount *
                                                        ((orderAmount >=
                                                        parseFloat(
                                                            wholesale_min_amount
                                                        )
                                                            ? parseFloat(
                                                                  wholesale_price
                                                              ) -
                                                              (parseFloat(
                                                                  wholesale_discount
                                                              ) || 0)
                                                            : parseFloat(
                                                                  retail_price
                                                              ) -
                                                              (parseFloat(
                                                                  retail_discount
                                                              ) || 0)) -
                                                            (is_special_offer
                                                                ? parseFloat(
                                                                      special_offer_discount
                                                                  ) || 0
                                                                : 0)),
                                                    true
                                                )}
                                                تومان
                                            </div>
                                        </div>
                                    </Fragment>
                                ) : (
                                    <h4 className='text danger'>
                                        موجودی این رنگ تمام شده است
                                    </h4>
                                )}
                            </div>
                        </div>
                    </div>
                    {description && (
                        <div className='description'>
                            <h3 className='caption'>توضیحات</h3>
                            <div className='text'>{description}</div>
                        </div>
                    )}

                    {relatedItems && relatedItems.length > 0 && (
                        <div className='relatedItems'>
                            <h2 className='caption'>کالاهای مرتبط</h2>
                            <ListScroll
                                items={relatedItems}
                                count={5}
                                Component={ItemCard}
                                key={id}
                            />
                        </div>
                    )}

                    <div className='comments'>
                        <div className='putComment'>
                            {canComment ? (
                                <div className='enabled'>
                                    {selectedComment &&
                                    selectedComment.message ? (
                                        <div className='repling_to text info'>
                                            <i className='ri-question-answer-line'></i>
                                            در حال پاسخ به نظر : <br />"
                                            {selectedComment.message}"
                                        </div>
                                    ) : (
                                        <div className='hint text info'>
                                            <i className='ri-feedback-line text '>
                                                {" "}
                                            </i>
                                            برای پاسخ دادن به هر نظر بر روی آن
                                            نظر کلیک کنید / ضربه بزنید تا رنگ آن
                                            تغیر کند سپس متن خود را بنویسید.
                                        </div>
                                    )}
                                    <textarea
                                        ref={this.newComment}
                                        name='comment'
                                        placeholder='لطفا نظر خود را در مورد این کالا با دیگران به اشتراک بگذارید'
                                    ></textarea>
                                    <button
                                        className='btn confirm'
                                        onClick={this.sendComment}
                                    >
                                        ارسال نظر
                                    </button>
                                </div>
                            ) : (
                                <div className='disabled text info'>
                                    فقط کاربران
                                    <div className='highlight text danger'>
                                        عضو
                                    </div>
                                    که
                                    <div className='highlight text danger'>
                                        این کالا را قبلا خریده اند
                                    </div>
                                    میتوانند در مورد آن نظر بدهند.
                                </div>
                            )}
                        </div>
                        <div className='commentsList'>
                            <div className='caption'>نظرات</div>

                            {comments && comments.length > 0 ? (
                                comments.map((comment) => {
                                    return (
                                        <Comment
                                            comment={comment}
                                            key={comment.id}
                                            onClick={this.onCommentClick}
                                        />
                                    );
                                })
                            ) : (
                                <div className='noComments text danger'>
                                    هنوز کاربری در مورد این کالا نظری ارسال
                                    نکرده است.
                                </div>
                            )}
                        </div>
                        <div className='allComments'></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Item);
